de:
  acceptInvite:
    continueWithFacebookText: 'Oder mit Facebook fortfahren'
    firstNameErrorRequired: Vorname darf nicht leer sein
    firstNameLabel: Vorname
    firstNamePlaceholder: Geben Sie Ihren Vornamen ein
    helloFNameText: 'Hallo {{fName}}'
    lastNameErrorRequired: Nachname darf nicht leer sein
    lastNameLabel: Nachname
    lastNamePlaceholder: Geben Sie Ihren Nachnamen ein
    otpLabel: 2FA aktivieren
    otpSecretErrorRequired: Dieses Feld ist erforderlich.
    otpSecretLabel: Bitte scannen Sie den QR-Code mit der Authenticator-App und verifizieren Sie
    otpSecretPlaceholder: Von der Authenticator-App bereitgestellter Code
    passwordConfirmationErrorRequired: Passwortbestätigung darf nicht leer sein
    passwordConfirmationLabel: Passwortbestätigung
    passwordConfirmationPlaceholder: Bestätigen Sie Ihr Passwort
    passwordError: 'Passwort {{passwordError}}'
    passwordErrorRequired: Passwort darf nicht leer sein
    passwordLabel: Passwort
    passwordPlaceholder: Geben Sie Ihr Passwort ein
    passwordShouldBeStrong: 'Das Passwort sollte mindestens 8 Zeichen lang sein, kein gängiges Wort sein und Groß- und Kleinbuchstaben, Zahlen und Symbole enthalten.'
    passwordShouldMatchError: Passwort sollte mit der Passwortbestätigung übereinstimmen
    provideYourDetailsText: 'Bitte geben Sie Ihre Daten ein, um fortzufahren:'
    signInWithFacebookBtn: Mit Facebook anmelden
    signUpBtn: Registrieren
    welcomeToSRText: Willkommen bei Shuttlerock
  accountSettings:
    accountSettingsUpdated: Kontoeinstellungen aktualisiert.
    clientNameLabel: Kundenname
    clientNamePlaceholder: Kundenname
    edit: Bearbeiten
    emailLabel: E-Mail
    emailPlaceholder: E-Mail
    emailemail: Dies sollte eine gültige E-Mail-Adresse sein.
    emailrequired: Dieses Feld ist erforderlich.
    firstNameLabel: Vorname
    firstNamePlaceholder: Vorname
    firstNamerequired: Dieses Feld ist erforderlich.
    lastNameLabel: Nachname
    lastNamePlaceholder: Nachname
    lastNamerequired: Dieses Feld ist erforderlich.
    loading: Wird geladen …
    notificationValidatedBody: 'Ihre Bestätigung wurde erneut an {{ email }} gesendet.'
    notificationValidatedHeader: E-Mail erneut gesendet
    notificationWarningBody: 'Wir haben eine E-Mail an die unten angegebene Adresse gesendet. Bitte bestätigen Sie, um Ihr Konto zu aktivieren. Keine E-Mail erhalten? <1>Bestätigung erneut senden</1>'
    notificationWarningHeader: Bitte bestätigen Sie Ihr E-Mail-Konto
    passwordLabel: Passwort
    reset: Zurücksetzen
    submit: Änderungen speichern
    title: Kontoeinstellungen
  accountType:
    subscription: Abonnement
    unrestricted: Uneingeschränkte Bestellungen
  advertListPage:
    addAdvert: Weiteres Konzept hinzufügen
    modalDeleteCancelButton: Abbrechen
    modalDeleteConfirmationButton: Konzept löschen
    modalDeleteConfirmationText: Möchten Sie dieses Konzept wirklich löschen? Nach dem Löschen können Sie es nicht wiederherstellen.
    modalDeleteConfirmationTitle: 'Löschen: Konzept {{name}}'
    successDeleteContent: Ihre Anzeige wurde erfolgreich gelöscht.
    successDeleteHeader: Anzeige gelöscht
  conceptPanel:
    submitToProduction: Zur Produktion einreichen
    designersLabel: Designer
    designersPlaceholder: 'Designer auswählen {{artDirector}}'
    designersUpdated: Designer aktualisiert
    productionMetadataErrorUpdate: Produktionsmetadaten konnten nicht aktualisiert werden. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.
    no: Nein
    notes: Notizen
    notesUpdated: Notizen aktualisiert
    untitledConceptName: 'Unbenanntes Konzept'
    primaryLanguageLabel: Primäre Sprache
    primaryLanguageErrorLoading: Sprachen konnten nicht geladen werden, bitte versuchen Sie es erneut
    primaryLanguageErrorRequired: Primäre Sprache ist erforderlich
    primaryLanguageErrorUpdate: Primäre Sprache konnte nicht aktualisiert werden, bitte versuchen Sie es erneut
    marketShortLabel: Markt
    targetAudience: 'Zielgruppe:'
    targetAudienceInterests: 'Interessen:'
    targetAudienceGenderAll: 'Alle Geschlechter'
    targetAudienceGenderFemale: 'Weiblich'
    targetAudienceGenderMale: 'Männlich'
    targetAudienceLifestyle: 'Lebensstil:'
    targetAudienceLocation: 'Standort:'
    yes: Ja
    localisation:
      localisationInstructions: Lokalisierungsanweisungen
      localisationAssets: Lokalisierungs-Assets
      noInstructionsProvided: (Keine Anweisungen bereitgestellt)
      primaryTargetMarket: Primärer Zielmarkt (Ausgangssprache)
      additionalTargetMarkets: Zusätzliche Zielmärkte
      localiseCopy: Text lokalisieren
      localiseAsset: Asset lokalisieren
      localiseVoiceover: Voiceover lokalisieren
      additionalInstructions: Zusätzliche Anweisungen
      translationStringsSheetURL: URL zum Übersetzungs-Strings-Sheet
    deliverableTable:
      baseDeliverables: 'Zusätzliche Format-Deliverables ({{count}}/{{total}})'
      copyFilenameError: 'Dateiname konnte nicht in die Zwischenablage kopiert werden'
      copyFilenameSuccess: 'Dateiname in die Zwischenablage kopiert!'
      details: Details
      dimension: Abmessung
      duration: Dauer-Kategorie
      expressProject: Express-Projekt
      filename: Dateiname
      format: Format
      hero: Hero
      variations: Variationen
      variation: 'Variation {{index}} - {{name}}'
      heroDeliverables: 'Hero-Deliverables ({{count}}/{{total}})'
      viewLink: Ansehen
    workflow:
      error:
        update: Aktualisierung der Unterstufe fehlgeschlagen
        validation: Aktualisierung der Stufe aufgrund von Validierungsfehlern fehlgeschlagen
    ugcInformation:
      sectionLabel: UGC-Ideenfindung und Creator-Briefing
      alert:
        title: Nur zur Referenz
        content: Dieser Inhalt wurde für UGC-Creator und das Team für die Ideenfindung kuratiert und bietet nur zusätzlichen Kontext für die Hero-Produktion.
      brandDetails:
        brandDetailsLabel: Markendetails
        productPositioningLabel: 'Marken-/Produktpositionierung:'
        socialChannelsLabel: 'Social-Channels:'
      conceptDirectionLabel: UGC-Konzeptausrichtung
      approachLabel: Ansatz
      deliverableLabel: UGC-Deliverable
      creatorPreferences:
        preferencesLabel: Creator-Präferenzen
        ageLabel: 'Alter:'
        genderLabel: 'Geschlecht:'
        ethnicityLabel: 'Ethnizität:'
        locationLabel: 'Standort:'
        hobbiesLabel: 'Interessen und Hobbys:'
        extraRequirementsLabel: 'Zusätzliche Anforderungen:'
      procurementLabel: Produktbeschaffung
      voiceOverInstructionsLabel: Skript- oder Voice-over-Anweisungen
      languageLabel: Sprache
      additionalInstructionsLabel: Zusätzliche Creator-Anweisungen
      hookLabel: Der Hook
      doAndDontLabel: Dos & Don’ts
      legalRequirementsLabel: Rechtliche Anforderungen
      sellingPointsLabel: Alleinstellungsmerkmale
    ugcBrandAssetsLabel: UGC-Brand-Assets
    ugcReferenceAssetsLabel: UGC-Referenz-Assets
    ugcDeliverablesLabel: UGC-Deliverables
  advertsSummary:
    duration: '({{length}} Sekunden)'
    edit: Bearbeiten
    noVariations: Keine Variationen
    orderSummary: BESTELLÜBERSICHT – GESAMTE BESTELLUNG
    variations_one: '{{count}} Variation'
    variations_other: '{{count}} Variationen'
    wouldYouLike: Möchten Sie eine weitere Anzeige hinzufügen?
  aiModels:
    label: Bevorzugte KI-Modelle
    category:
      IMAGE: Bilder
      VIDEO: Video
      AUDIO: Audio
      MUSIC: Musik
      VOICE: Voice-over
    model:
      all: Beliebiges KI-Modell
      none: Keine
      default: Standard
  alert:
    goBack: Zurück
    guestThanksReturnToSignInBtn: Zurück zur Anmeldung
    notFoundPageNotFoundText: Die Seite, die Sie suchen, konnte nicht gefunden werden.
    notFoundSupportEmailText: Sind Sie einem Link von einer anderen Stelle dieser Website oder von einer anderen Website gefolgt? Wenn ja, schreiben Sie uns bitte an {{supportEmail}}, damit wir das Problem beheben können.
    notFoundTitle: Seite nicht gefunden
    oopsOhNoTitle: Oh nein!
    oopsSomethingWentWrongText: Etwas ist schiefgelaufen.
    oopsTryAgainLaterText: Bitte versuchen Sie es später erneut. Wenn das Problem in ein paar Stunden nicht behoben ist, wenden Sie sich bitte an unser Support-Team.
    orderThanksHomeButton: Zur Startseite
    orderThanksText: Ihr Projekt wurde eingereicht. Unsere Designer beginnen mit der Arbeit, sobald Ihr Briefing geprüft wurde.
    orderThanksTitle: Vielen Dank
    orderThanksTrackYourOrderButton: Projekt verfolgen
    v1BriefNotExistsText: Die Details Ihres Projekts sind in Shuttlerock Cloud nicht mehr vorhanden. Wenden Sie sich bei Bedarf an Ihren Creative Specialist, um eine Kopie Ihres Briefings zu erhalten.
  assetPicker:
    audio: Audiodateien
    brand: Markenrichtlinien-Dateien
    browseFiles: Dateien durchsuchen
    compressed: ZIP-Dateien
    dropFiles: Legen Sie Ihre Dateien hier ab
    font: Schriftdateien
    logo: Logodateien
    music: Audiodateien
    placeholder: Dateien hier ablegen oder
    stills: Bilder
    uploaderMaxFiles: Es tut uns leid, für dieses Produkt können maximal {{count}} Assets hochgeladen werden
    uppyError: Beim Hochladen der Datei(en) ist ein Problem aufgetreten
    video: Videodateien
  assetUploader:
    notesPlaceholder: Notizen zu dieser Datei hinzufügen
    preferredFileTypes: 'Bevorzugte Dateitypen:'
  assetsForm:
    assetUploadError: Beim Laden Ihrer Dateien ist ein Problem aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.
    brandFontSupportedTypes: 'Unterstützte Dateitypen: .otf, .ttf, .fnt, .ttc und .woff'
    brandFontTitle: Marken-Schriftarten
    brandGuidelinesSupportedTypes: 'Unterstützte Dateitypen: .png, .jpg, .jpeg, .psd, .ai, .eps, .svg und .pdf'
    brandGuidelinesTitle: Markenrichtlinien
    brandLogoNOTSupportedTypes: .tif und .tiff werden von unseren Upload-Funktionen nicht unterstützt
    brandLogoSupportedTypes: 'Unterstützte Dateitypen: .png, .jpg, .jpeg, .psd, .ai, .eps, .tif, .tiff und .svg'
    brandLogoTitle: Markenlogo(s)
    brandMusicInformation: Wenn keine Musik bereitgestellt wird, wählt Shuttlerock passende Musik aus und verwendet diese.
    brandMusicSupportedTypes: 'Unterstützte Dateitypen: .wav, .mp3, .aiff, .m4a, .flac, .alac, .aac und .wma'
    brandMusicTitle: Musikdatei(en)
    cancelBtn: Zurück
    fontLabel: Schriftart
    guidelinesLabel: Richtlinien
    instructions: Bitte laden Sie alle Logos, Schriftarten und Markenrichtlinien hoch, die wir für die Erstellung Ihrer Videos benötigen. Stellen Sie nach Möglichkeit die höchste verfügbare Auflösung bzw. Größe bereit.
    logoLabel: Logo
    minimizeBtnLabel: Minimieren
    musicLabel: Musik
    optional: Optional
    preferred: bevorzugt
    requiredInformation: '* Erforderlich'
    sectionInstructions: Laden Sie Ihre Marken-Assets hoch
    submitBtn: Weiter
    supportedFileTypes: 'Unterstützte Dateitypen:'
    title: Marken-Assets
    viewAllBtnLabel: Alle anzeigen
    whatToUpload: Was soll hochgeladen werden
  authForm:
    continueWithFacebook: Mit Facebook fortfahren
    continueWithGoogle: Mit Google fortfahren
    emailErrorEmail: Bitte geben Sie eine gültige E-Mail ein
    emailErrorRequired: E-Mail ist erforderlich
    emailLabel: E-Mail-Adresse
    emailPlaceholder: E-Mail-Adresse
    facebookAuthorizationFailed: Facebook-Autorisierung fehlgeschlagen
    forgotPasswordLink: Passwort vergessen?
    getStarted: Los geht’s
    googleAuthorizationFailed: Google-Autorisierung fehlgeschlagen
    heading: Anmelden
    notAUser: 'Noch kein Benutzer? '
    otpAttemptLabel: Einmalpasswort
    otpAttemptPlaceholder: Einmalpasswort aus der Authenticator-App eingeben
    otpLabel: 2FA
    passwordErrorRequired: Passwort ist erforderlich
    passwordLabel: Passwort
    passwordPlaceholder: Passwort eingeben
    passwordResetSuccessMessage: Ihr Passwort wurde zurückgesetzt. Bitte melden Sie sich mit Ihrem neuen Passwort an.
    rememberMeLabel: Angemeldet bleiben
    signInBtn: Anmelden
    signInError: Es ist ein Problem aufgetreten. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Support.
    signInWithEmail: Mit E-Mail anmelden
    signInWithFacebookBtn: Mit Facebook anmelden
  brandAssets:
    brandNotesLabel: Gibt es kreative oder rechtliche Anforderungen, die wir für Ihre Marke berücksichtigen sollen?
    brandNotesPlaceholder: Hier eingeben
    formDescription: Laden Sie hier Ihr Logo, Ihre Schriftarten, Markenrichtlinien usw. hoch. Teilen Sie uns mit, wie wir Ihre Marke am besten darstellen.
    formTitle: Marken-Assets
    next: Weiter
    reviewMyOrder: Bestellung prüfen
    save: Speichern und beenden
    selectedLogosErrorRequired: Bitte laden Sie mindestens eine Logodatei hoch
    selectedLogosLabel: Bitte laden Sie Ihr(e) Markenlogo(s) hoch
    selectedOthersHelp: Wenn nichts bereitgestellt wird, wählt Shuttlerock passende Audiodateien und/oder Schriftarten aus und verwendet diese.
    selectedOthersLabel: Bitte laden Sie Ihre Schriftarten, Markenrichtlinien und Audiodateien hoch
  brandAssetsManagement:
    title: 'Marken-Assets: {{name}}'
  briefTracker:
    brandAssets: Marken-Assets
    campaignDetails: Kampagnendetails
    summary: Zusammenfassung
  clientForm:
    accountTypeDescriptionUnrestricted: Für diesen Kontotyp gibt es keine Einschränkungen bei Bestellungen
    accountTypeErrorRequired: Kontotyp ist erforderlich
    accountTypeLabel: Wie werden Bestellungen für diesen Kunden verwaltet?
    cancelBtn: Abbrechen
    cannotBeEditedWarning: 'Hinweis: Dies kann nach dem Erstellen nicht mehr bearbeitet werden'
    clientCreated: Kunde erstellt
    clientPartnersErrorRequired: Kundenpartner ist erforderlich
    clientPartnersLabel: Kundenpartner
    clientPartnersPlaceholder: Kundenpartner auswählen
    creativeSpecialistsErrorRequired: Creative Specialists sind erforderlich
    creativeSpecialistsLabel: Creative Specialists
    creativeSpecialistsPlaceholder: Creative Specialists auswählen
    descriptionLabel: Beschreibung
    descriptionPlaceholder: Geben Sie einen kurzen Satz zur Beschreibung des Kunden ein
    facebookUrlLabel: Facebook-URL
    facebookUrlPlaceholder: Facebook-URL eingeben
    hubspotIdErrorRequired: HubSpot-ID ist erforderlich
    hubspotIdLabel: HubSpot-Unternehmens-ID
    hubspotIdPlaceholder: HubSpot-ID des Kundenunternehmens eingeben
    instagramUrlLabel: Instagram-URL
    instagramUrlPlaceholder: Instagram-URL eingeben
    loggedOutDownloadingLabel: Abgemeldeten Benutzern das Herunterladen von Creatives erlauben
    nameCannotBeEditedWarning: 'Hinweis: Dies kann nicht mehr bearbeitet werden, sobald eine Bestellung aufgegeben wurde'
    nameErrorRequired: Name ist erforderlich
    nameLabel: Kundenname
    namePlaceholder: Namen des Kunden eingeben
    no: Nein
    otherUrlLabel: Sonstige
    otherUrlPlaceholder: z. B. https://www.example.com/
    pinterestUrlLabel: Pinterest-URL
    pinterestUrlPlaceholder: Pinterest-URL eingeben
    platformsErrorRequired: Plattformen sind erforderlich
    platformsLabel: Bitte wählen Sie die Plattform(en) aus, die für individuelle Bestellungen verfügbar sind
    platformsPlaceholder: Plattformen auswählen
    preApprovalDownloadingLabel: Kunden das Herunterladen von Creatives vor der Genehmigung erlauben
    regionErrorRequired: Vertriebsgebiet ist erforderlich
    regionLabel: Vertriebsgebiet
    regionPlaceholder: Vertriebsgebiet auswählen
    sectionClientDetails: Kundendetails
    sectionDownloads: Downloads
    sectionOrdering: Bestellungen
    sectionShuttlerockDetails: Shuttlerock-Details
    submitBtn: Einreichen
    successUpdateBody: '{{clientName}} wurde erfolgreich aktualisiert.'
    successUpdateHeader: Kunde aktualisiert
    tiktokUrlLabel: TikTok-URL
    tiktokUrlPlaceholder: TikTok-URL eingeben
    twitterUrlLabel: Twitter-URL
    twitterUrlPlaceholder: Twitter-URL eingeben
    verticalLabel: Branche
    verticalPlaceholder: Bitte auswählen
    websiteUrlLabel: Website-URL
    websiteUrlPlaceholder: Website-URL eingeben
    yes: Ja
    youtubeUrlLabel: YouTube-URL
    youtubeUrlPlaceholder: YouTube-URL eingeben
  clientList:
    actionBtnAriaLabel: Aktionsmenü für Kunden öffnen
    actionsLabel: Aktionen
    assetsBtn: Marken-Assets
    clientCopiedContent: Die Kunden-ID für {{clientName}} wurde in Ihre Zwischenablage kopiert
    clientCopiedTitle: Kunden-ID kopiert!
    clientNameLabel: Kundenname
    clientSearchLabel: Suchen
    copyClientId: Kunden-ID kopieren
    editBtn: Bearbeiten
    emptyTableMessage: Es sind keine Kunden vorhanden. Klicken Sie oben auf „Neuer Kunde“, um einen neuen Kunden hinzuzufügen.
    header: 'Kunden: {{name}}'
    manageUsersBtn: Benutzer verwalten
    newClientBtn: Neuer Kunde
    ownerEmailLabel: E-Mail des Inhabers
    salesTerritoriesPlaceholder: Alle Vertriebsgebiete
    salesTerritoryLabel: Vertriebsgebiet
  colorpicker:
    close: Schließen
    notesPlaceholder: Notizen zu dieser Farbe hinzufügen
  common:
    loadMoreBtn: Mehr laden
  confirmOrderErrorModal:
    description: Kehren Sie zum Produktionsbriefing zurück, wenn Sie bereit sind, es erneut einzureichen.
    return: Zurück zum Produktionsbriefing
  confirmOrderModal:
    approveBriefToastMessage: Das Briefing wurde genehmigt und die Asset-Ordner in Google Drive werden erstellt. Anschließend wechselt die Bestellung in den Status „In Bearbeitung“.
  datepicker:
    applyCustomDate: Benutzerdefiniertes Datum anwenden
    phrases:
      close: Schließen
      datepickerEndDateLabel: 'Enddatum:'
      datepickerEndDatePlaceholder: Enddatum auswählen
      datepickerStartDateLabel: 'Startdatum:'
      datepickerStartDatePlaceholder: Startdatum auswählen
      endDateAriaLabel: Enddatum
      endDatePlaceholder: Enddatum
      resetDates: Daten zurücksetzen
      startDateAriaLabel: Startdatum
      startDatePlaceholder: Startdatum
  deliverableState:
    approved: Genehmigt
    client_review: Kunden-Review
    expired: Abgelaufen
    internal_review: Interne Review
    internally_rejected: Intern abgelehnt
    pending_delivery: Lieferung ausstehend
    rejected: Abgelehnt
  dimensionInput:
    addBtnLabel: Hinzufügen
    dimensionAlreadyExistsError: Diese Abmessungen existieren bereits
    heightLabel: Höhe
    heightLessThanError: 'Höhe muss kleiner als {{max}} sein'
    heightMoreThanError: 'Höhe muss größer als {{min}} sein'
    heightRequiredError: Höhe ist erforderlich
    information: Bitte geben Sie Ihre erforderlichen Abmessungen in Pixeln ein.
    widthHeightLessThanError: 'Breite/Höhe muss kleiner als {{max}} sein'
    widthHeightMoreThanError: 'Breite/Höhe muss größer als {{min}} sein'
    widthHeightRequiredError: Breite/Höhe sind erforderlich
    widthLabel: Breite
    widthLessThanError: 'Breite muss kleiner als {{max}} sein'
    widthMoreThanError: 'Breite muss größer als {{min}} sein'
    widthRequiredError: Breite ist erforderlich
  editCopyModal:
    callToAction: Call to Action
    ctaDescription: Führt die Nutzer zu einer bestimmten Aktion
    mockupDescription: Dies ist kein Mockup für Ihr Projekt. Das Bild soll lediglich veranschaulichen, wie der Werbetext aufgebaut sein sollte.
    mockupTitle: Beispiel für ein Video-Mockup
    primaryCopy: Der primäre Text ist die Kernbotschaft, die Sie vermitteln möchten
    saveAndClose: Speichern und schließen
    saveAndOpenNext: Speichern und nächste Variation öffnen
    secondaryCopy: Die sekundäre Botschaft hebt den Nutzen des Produkts hervor
    tertiaryCopy: Der tertiäre Text unterstützt Ihre primäre und sekundäre Botschaft.
  emailConfirmationResent:
    body: Wir haben Ihre Bestätigungs-E-Mail erneut gesendet. Bitte bestätigen Sie sie, um Ihr Konto zu aktivieren. Keine E-Mail erhalten? Prüfen Sie Ihre E-Mail-Adresse in den <1>Kontoeinstellungen</1>
    heading: E-Mail erneut gesendet
  emailConfirmed:
    body: Vielen Dank, dass Sie Ihre E-Mail-Adresse {{email}} bestätigt haben.
    heading: E-Mail bestätigt
  error:
    errorLabel: Fehler
    gqlError: Entschuldigung, etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.
    invalidUrl: Dies sollte eine gültige URL sein.
    networkIssue: Entschuldigung, bei unserem Netzwerk ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.
    okButtonText: OK
    oopsIntroText: Ups! Ein Fehler ist aufgetreten!
    orderNotFoundToastMessage: Nutzen Sie den Live-Chat, um mit einem Shuttlerock Cloud Specialist zu sprechen, oder schreiben Sie an <1> help@shuttlerock.com </1>
    orderNotFoundToastTitle: Sie haben keinen Zugriff auf dieses Briefing
  exportSpinner:
    close: Schließen
    exportCompleted: Export abgeschlossen
    exportSpinnerText: '{{successCount}} von {{totalCount}} Deliverables exportiert'
    facebookGenericErrorMessage: Export fehlgeschlagen. Wenn das Problem weiterhin besteht, <2>wenden Sie sich bitte an den Support</2>.
  facebookDetails:
    checkYourDetails: Bitte prüfen Sie Ihre Daten
    content: Wir haben diese Informationen aus Ihrem Facebook-Konto übernommen. Sie können die Angaben unten ändern oder später in den Kontoeinstellungen bearbeiten.
    edit: Bearbeiten
    emailLabel: E-Mail
    emailPlaceholder: E-Mail
    emailemail: Dies sollte eine gültige E-Mail-Adresse sein.
    emailrequired: Dieses Feld ist erforderlich.
    firstNameLabel: Vorname
    firstNamePlaceholder: Vorname
    firstNamerequired: Dieses Feld ist erforderlich.
    lastNameLabel: Nachname
    lastNamePlaceholder: Nachname
    lastNamerequired: Dieses Feld ist erforderlich.
    loading: Wird gesendet …
    noEmailPermission: Sie haben sich entschieden, Ihre E-Mail-Adresse nicht mit Shuttlerock zu teilen. Bitte fügen Sie eine E-Mail-Adresse hinzu, damit wir Ihnen wichtige Projekt-Updates senden und prüfen können, ob die Angaben zu Ihrem Konto korrekt sind.
    submit: Senden und fortfahren
    title: 'Ihre Daten:'
    welcomeToSRText: Willkommen bei Shuttlerock
  fileType:
    audio: Audio
    brand: Marke
    brand_logo: Markensymbol
    compressed: ZIP
    font: Schriftart
    logo: Logo
    reference: Referenz
    stills: Bilder
    text_field: Zusätzliche Dateien
    video: Video
  footer:
    privacy: Datenschutz
    support: Support
    supportRequest: Support-Anfrage {{name}}
    terms: Bedingungen
  formatLengths:
    durationSelectOptionsTitle: Dauer
  general:
    cancel: Abbrechen
    confirm: Bestätigen
    create: Erstellen
    delete: Löschen
    dimension: '{{width}}B : {{height}}H'
    directDownloadSuccess: Download gestartet.
    disclaimer: Indem Sie fortfahren, stimmen Sie der <1>Datenschutzerklärung</1> und den <3>Nutzungsbedingungen</3> von Shuttlerock zu.
    download: Herunterladen
    edit: Bearbeiten
    error: Fehler
    googleDrive: Google Drive
    hero: Hero
    link: Link
    loading: Wird geladen
    next: Weiter
    no: Nein
    onBeforeUnloadMessage: Ihre Änderungen wurden möglicherweise nicht gespeichert.
    pleaseEnterBetween: Bitte geben Sie einen Wert zwischen {{min}} und {{max}} ein
    pleaseEnterWholeNumber: Bitte geben Sie eine ganze Zahl ein
    previous: Zurück
    review: Prüfen
    save: Speichern
    saveAndExit: Speichern und beenden
    search: Suchen
    select: Auswählen
    success: Erfolg!
    update: Aktualisieren
    view: Ansehen
    viewAll: 'Alle anzeigen: {{name}}'
    viewFullList: Vollständige Liste anzeigen ({{ number }})
    viewLess: Weniger anzeigen
    yes: Ja
  header:
    briefSummaryHeaderText: Briefing-Zusammenfassung
    demoSiteWarning: NUR DEMO – BITTE BEACHTEN SIE, DASS BESTELLUNGEN NICHT BEARBEITET WERDEN
    editClientHeaderText: Kunde bearbeiten
    newClientHeaderText: Kunde erstellen
    newOrderHeaderText: Projekt erstellen
    orderDeliverableUploadHeaderText: Deliverables hochladen
    orderFormHeaderText: Bestellformular
    orderInternalDeliverableListHeaderText: Creatives liefern
    signInLink: Anmelden
    signInText: Bereits registriert?
    userInviteHeaderText: Benutzer einladen
    usersListHeaderText: 'Benutzer: {{name}}'
  mainMenu:
    accountSettings: Kontoeinstellungen
    signOut: Abmelden
    support: Support
  inputElement:
    inputPlaceholder: Geben Sie hier Ihre Antwort ein …
  instantAnswer:
    checkboxValuesNumber: 'Es sollten mindestens {{minSelected}} und höchstens {{maxSelected}} Optionen ausgewählt werden.'
    requiredFieldText: Dieses Feld ist erforderlich
  lightbox:
    aviNotSupported: Leider können AVI-Dateien in diesem Browser nicht abgespielt werden.
    dimensionsLabel: 'Abmessungen:'
    downloadAssets: Asset herunterladen
    durationLabel: 'Dauer:'
    fileSizeLabel: 'Dateigröße:'
    fileTypeLabel: 'Dateityp:'
    resolutionLabel: 'Auflösung:'
    staticDuration: Statisch
  objectives:
    brand_awareness: Markenbekanntheit
    consideration: Erwägung
    direct_response: Direkte Reaktion
    full_funnel: Full Funnel
    unknown: Unbekannt
  orderAdvertAnswers:
    assetsErrorRequired: Bitte wählen Sie mindestens ein Asset für dieses Anzeigenpaket aus
    assetsLabel: Laden Sie die Assets hoch, die Sie in diesem Konzept verwenden möchten, und/oder klicken Sie darauf
    assetsTooltip: Empfehlungen zur Asset-Auswahl<br/><strong>Statisch:</strong> 1 Bild<br/><strong>6-Sekunden-Video:</strong> 1 Video oder 1 Bild<br/><strong>15-Sekunden-Video:</strong> 1 Video und/oder 5 Bilder<br/><strong>30-Sekunden-Video:</strong> 1 Video und/oder 15 Bilder<br/>
    autoSaveInfo: Ihr Fortschritt wird automatisch gespeichert
    clickToAdd: Klicken Sie, um Assets im Vorschaubereich hinzuzufügen
    conceptVariationTitle: 'Konzeptdetails: {{advertName}} – Konzept {{ variationNumber }} '
    formDescription: Wählen Sie die Assets aus und geben Sie den Text an, den unsere Designer für die Erstellung Ihres Konzepts verwenden.
    formTitle: 'Konzeptdetails: {{name}}'
    languagesErrorRequired: Dies ist eine Pflichtfrage
    languagesLabel: Wählen Sie die Sprachen aus, für die Sie Übersetzungen benötigen ({{numLanguages}} erforderlich)
    languagesPlaceholder: Sprache
    languagesVariationInformation: Ihr übersetzter Text wird zu einem späteren Zeitpunkt abgefragt.
    noResponseText: Keine
    noVariations: Keine Variationen
    numOfLanguagesError: Sie müssen {{numLanguagesToSelect}} Sprachen auswählen
    objectiveErrorRequired: Dies ist eine Pflichtfrage
    objectiveLabel: Was beschreibt Ihr Kampagnenziel am besten?
    objectiveShortLabel: Kampagnenziel
    overview: Übersicht der Videospezifikationen
    productOrServiceShortLabel: Produkt/Dienstleistung
    required: Eine Antwort auf diese Frage ist erforderlich
    submit: Einreichen
    submitting: Wird geladen …
    useRootAdvertAnswersFalse: Werbetext ändern
    useRootAdvertAnswersLabel: Sie können Ihren Text für diese Variation beibehalten oder einen neuen Text angeben.
    useRootAdvertAnswersTrue: '*Werbetext beibehalten'
  orderAdvertList:
    accessDeniedMsg: Bestellungen können nach dem Einreichen nicht mehr bearbeitet werden.<br /> Wenden Sie sich an unser Support-Team, wenn Sie Änderungen benötigen.
    heading: Bestelldetails
    modalDeleteCancelButton: Abbrechen
    modalDeleteConfirmationButton: Konzept löschen
    orderSaved: Ihre Bestellung wurde gespeichert
    reviewMessage: Sobald Sie mit Ihrem Briefing beginnen, können Sie Ihre Bestelldetails nicht mehr bearbeiten.
    save: Speichern und beenden
    startBrief: Briefing starten
    subHeading: Prüfen Sie Ihre Angaben, bevor Sie Ihre Bestellung einreichen.
    totalOrderDeliverables: Deliverables der Bestellung
  orderAdvertNew:
    orderAdvertFormHeaderText: Individuelle Bestellung
    platformRequired: Bitte wählen Sie mindestens eine Plattform aus
    reviewBtn: Bestellung prüfen
  orderAdvertNewSummary:
    advertSummaryTitle: Anzeigenübersicht
  orderAnswersEdit:
    assetsDescription: Bitte laden Sie alle Bilder, Videos, Audiodateien und anderen Assets hoch, die Sie in dieser Bestellung verwenden möchten. <br/> Kampagnen-Assets können auch auf den folgenden Seiten hochgeladen werden.
    assetsErrorRequired: Bitte laden Sie mindestens eine Kampagnen-Asset-Datei hoch
    assetsHelp: Aus diesen Assets wählen Sie beim Briefing der einzelnen Anzeigenpakete aus.
    assetsLabel: Kampagnen-Assets
    autoSaveInfo: Ihr Fortschritt wird automatisch gespeichert
    baseLanguageErrorRequired: Dieses Feld ist erforderlich
    baseLanguageLabel: Wählen Sie die Hauptsprache für Ihr Projekt
    baseLanguagePlaceholder: Sprache auswählen
    campaignQuestionsTitle: Kampagnenfragen
    formDescription: Nennen Sie uns Ihre Kampagnenziele, damit unsere Designer Anzeigen erstellen, die die gewünschten Ergebnisse erzielen.
    formTitle: Kampagnendetails
    languageTooltip: Die Hauptsprache wird für alle Assets verwendet, bevor Übersetzungen angewendet werden (falls zutreffend).
    required: Eine Antwort auf diese Frage ist erforderlich
  orderAssetEdit:
    submitBtn: Speichern und fortfahren
  orderBriefAnswerList:
    label:
      assetSources: Ergänzte Assets
    assetSources:
      supplementAssets: 'Bereitgestellte Assets ergänzen mit:'
      stockAssets: Stock-Assets
      website: Assets aus meinen Markenrichtlinien, der Website oder oben verlinkten Social-Plattformen
      aiEnhanced: KI-gestützte Assets
      none: Nur die von mir bereitgestellten Assets verwenden
    utility:
      assistant: Assistent
      notes: Notizen
      summary: Zusammenfassung
    STATIC: Statisch
    actionsSave: Speichern und beenden
    actionsSubmit: Briefing einreichen
    additionalDetails: Zusätzliche Anweisungen
    additionalNotes: Zusätzliche Notizen
    artDirectorLabel: Art Director
    artDirectorUpdated: Art Director aktualisiert
    assetNotes: Asset-Notizen
    assetsZipGeneratingTooltip: Die Asset-ZIP-Datei wird erstellt
    audio: Audio
    base: Basis
    baseCopyTranslationLabel: 'Basistext – {{language}}: '
    brandAssets: Marken-Assets
    brandDescription: Markenbeschreibung
    brandName: Marke
    brandPersonality: Markenpersönlichkeit
    brandRequirements: Rechtliche und kreative Anforderungen
    briefCsReviewAlertTitle: Dieses Briefing befindet sich derzeit in der CS-Review und kann erst genehmigt werden, wenn es in die Produktions-Review verschoben wurde.
    briefCsReviewInformation: Um ein Briefing in die Produktions-Review zu verschieben, öffnen Sie das Briefing und klicken Sie auf „Zur Produktions-Review einreichen“.
    briefSubmitted: 'Dieses Briefing wurde eingereicht und kann nicht mehr bearbeitet werden. Wenn Sie das Briefing aktualisieren müssen, wenden Sie sich an Ihren Creative Strategist'
    briefUgcAlertTitle: Dieses Briefing hat UGC-Anforderungen und befindet sich derzeit im Status {{state}}.
    briefUgcInformation: Es kann erst in die Produktions-Review verschoben werden, wenn die UGC-Produktion abgeschlossen ist.
    campaignDetails: Kampagnendetails
    channels: Kanäle
    clientAndBrandDetails: Kunden- und Markendetails
    clientDescription: Kundenbeschreibung
    clientName: Kunde
    collapseAll: Alles einklappen
    disclaimer: Disclaimer
    expandAll: Alles ausklappen
    conceptIdea: Konzeptidee
    conceptBasics: Grundlagen
    conceptVariation: 'Konzeptvariation {{ index }}'
    confirmOrderBtnLabel: Briefing genehmigen
    confirmOrderCancelBtnLabel: Abbrechen
    confirmOrderModalTitle: Möchten Sie dieses Briefing wirklich genehmigen?
    confirmSubmitOrderModalInformation: '<0>Sobald Sie auf <1>Einreichen</1> klicken, können Sie das Briefing nicht mehr bearbeiten.</0>'
    confirmSubmitOrderModalTitle: Sind Sie sicher?
    copyFilenameError: 'Dateiname konnte nicht in die Zwischenablage kopiert werden'
    copyFilenameSuccess: 'Dateiname in die Zwischenablage kopiert!'
    details: Details
    detailsLinkLabel: Details anzeigen
    dimension: Abmessung (px)
    downloadAssets: Assets herunterladen
    editLinkLabel: Bearbeiten
    editDetailsBtnLabel: Details bearbeiten
    editNotesBtnLabel: Notizen bearbeiten
    editNotesClickOutside: Klicken Sie außerhalb des Textbereichs, um Ihre Notizen zu speichern
    editNotesPlaceholder: Klicken Sie auf den Bearbeiten-Button, um Notizen hinzuzufügen. Klicken Sie außerhalb des Textfelds, um zu speichern
    fileName: Dateiname
    group: Gruppe
    internalNotesOnly: Nur interne Notizen
    projectLevelQuestions: Fragen auf Projektebene
    languageBaseLabel: 'Sprache:'
    languageLabel: Wählen Sie die Sprachen, für die Übersetzungen erforderlich sind
    languagesVariationInformation: Ihr übersetzter Text wird zu einem späteren Zeitpunkt abgefragt.
    languagesVariationInformationTitle: Übersetzungsvariation
    logo: Logo
    notesUpdated: Notizen aktualisiert
    orderDetails: Projektdetails
    orderName: 'Projektname:'
    projectDetailsSavedSuccess: Projektdetails gespeichert
    projectDetails: Projektdetails
    projectNotes: Projektnotizen
    orderNotificationInformation: 'Sie erhalten automatisch alle E-Mail-Updates zu diesem Projekt, zusammen mit den zugewiesenen Client Partnern und Creative Specialists'
    orderNotificationTitle: Wer soll Benachrichtigungen erhalten, wenn dieses Projekt bereit ist?
    platformSpecifics: Plattformspezifika
    productionBrief: Produktionsbriefing
    productionNotesPlaceholder: ' '
    productionTranslationLabel: 'Produktionsübersetzung: '
    projectOverviewBtn: Projektübersicht
    region: Region
    reviewYourDetails: Prüfen Sie die Details Ihres Briefings vor dem Einreichen. Nach dem Einreichen können Sie das Briefing nicht mehr bearbeiten.
    saveNotes: Notizen speichern
    messaging: Botschaften
    selectedAssets: Assets
    submitBtn: Einreichen
    submittedDateLabel: 'Einreichungsdatum:'
    delivery:
      deliveryDueDateLabel: 'Nächste Lieferung:'
      deliveryDueDateLinkLabel: Mehr erfahren
      nextDeliveryTooltip: '<0>{{linkText}}</0>, wie dies berechnet wird'
      changeDateLabel: Datum ändern
      adjustedDeliveryLabel: 'Angepasste Lieferung: '
      reasonLabel: Grund für angepasste Lieferung
      reasonPlaceholderLabel: Grund suchen oder eingeben
      requiredLabel: Erforderlich
      saveBtnLabel: Speichern
      toast:
        success: Nächste Lieferung angepasst
        saveError: Fehler beim Speichern
      reason:
        briefClarification: Klärung des Briefings erforderlich
        complexDeliverables: Komplexe Deliverables
        complexRevision: Komplexe Revision
        storyboard: Storyboard erforderlich
        creativeRework: Überarbeitung des Creatives
        midProductionChange: Änderungswunsch während der Produktion
        expeditedProject: Beschleunigtes Projekt
        splitDelivery: Geteilte Lieferung
        workingFileTat: Durchlaufzeit für Arbeitsdateien
        specialFormat: Spezielles Format mit individuellem Zeitplan
        regionalHoliday: Regionaler Feiertag (Kunde)
    summaryTitle: Briefing-Zusammenfassung
    tableDetails: Details
    tableDimension: Abmessung (px)
    tableLength: Maximale Dauer
    tablePlatform: Plattform
    totalDeliverables: 'Deliverables gesamt: {{count}}'
    totalOrderDeliverables: Deliverables der Bestellung gesamt
    translation: 'Übersetzung: {{ language }}'
    updateTranslationBtnLabel: Text übersetzen
    updateTranslationSuccessMessage: Übersetzungen wurden aktualisiert
    updateTrelloCardBtnLabel: Trello aktualisieren
    updateTrelloSuccessMessage: Trello-Karte wurde aktualisiert
    updatingTrelloBtnLabel: Wird aktualisiert …
    urlFacebook: Facebook
    urlInstagram: Instagram
    urlOther: Sonstiges
    urlTwitter: Twitter
    urlWebsite: Website
    urlYoutube: YouTube
    verticalName: Branche
    voiceOver: Voice-over
    websites: 'Kundenkanäle: '
  orderDeliverableList:
    adverts: Konzepte
    actionFilterBtnLabel: 'Filter ({{totalFilters}})'
    Advertiser: Werbetreibender
    alphaRevisionModalTitle: Revisionen einreichen?
    alphaRevisionModalBody: Sie erhalten eine E-Mail, wenn Ihr Creative zur Prüfung bereit ist. In dieser Zeit können keine weiteren Revisionen hinzugefügt werden.
    alphaRevisionModalBodyInternal: Das Projekt wird an unsere Designer zurückgesendet und die Lieferung an den Kunden verzögert sich. Bitte verschieben Sie die Trello-Karte auf „Revision Needed“.
    csat:
      reasonQuality: Creative-Qualität entsprach nicht unseren Erwartungen
      reasonTurnaround: Durchlaufzeiten waren länger als erwartet
      reasonInstructions: Anweisungen aus dem Briefing oder der Revision wurden nicht befolgt
      reasonCommunication: CSM-Support oder Kommunikation war schlecht
      reasonPlatform: Es gab Probleme mit der Shuttlerock-Plattform
      reasonOther: Sonstiges (bitte angeben)
    quickFixDialog:
      title: Bereit, wenn Sie es sind
      contentExpressDesign_one: Ihre {{count}} Revision wird innerhalb von <strong>4 Stunden</strong> mit unserem Express-Design-Service abgeschlossen! <0>
      contentExpressDesign_other: Ihre {{count}} Revisionen werden innerhalb von <strong>4 Stunden</strong> mit unserem Express-Design-Service abgeschlossen! <0>
      tooltipExpressDesign: Wenn Ihre Revisionen falsch kategorisiert wurden, werden Sie benachrichtigt und es gelten unsere Standard-Durchlaufzeiten
      contentReceiveEmail: Sie erhalten eine E-Mail, sobald Ihr Creative zur Prüfung bereit ist.
      buttonCancel: Abbrechen
      buttonSubmit: Revisionen einreichen
    projectRatingReasonLabel: Was ist der Grund für Ihre Antwort?
    projectRatingReasonPlaceholder: Option auswählen
    projectRatingCommentLabel: Super! Möchten Sie uns noch etwas mitteilen?
    projectRatingCommentPlaceholder: Möchten Sie das näher erläutern?
    projectRatingDialogTitle: Glückwunsch zur Genehmigung Ihres Projekts
    projectRatingDialogContentTitle: 'Wie zufrieden sind Sie mit diesem Projekt? <0>'
    projectRatingDialogLowSatisfaction: 'Überhaupt nicht <br /> zufrieden'
    projectRatingDialogModerateSatisfaction: 'Mäßig <br /> zufrieden'
    projectRatingDialogHighSatisfaction: 'Vollständig <br /> zufrieden'
    projectRatingDialogTooltip: Ihre Bewertung hilft uns, das beste Shuttlerock-Erlebnis für Sie zu schaffen
    projectRatingDialogValidation: Bitte wählen Sie eine Option, um fortzufahren
    projectRatingDialogCancel: Abbrechen
    projectRatingDialogApprove: Genehmigen
    'Approve Creatives': Creatives genehmigen
    approveProject: Projekt genehmigen
    approveProjectModalTitle: Projekt genehmigen?
    approveProjectModalBody: Ihr Projekt wird abgeschlossen und Sie können keine Revisionen mehr hinzufügen. Genehmigte Projekte können exportiert und heruntergeladen werden.
    'Business account': Geschäftskonto
    continueProductionBtn: Produktion fortsetzen
    continueProductionModalTitle: Produktion fortsetzen?
    continueProductionModalBody: Unsere Designer wechseln in die nächste Phase Ihres Projekts. In dieser Zeit können keine weiteren Revisionen hinzugefügt werden. Sie erhalten eine E-Mail, wenn Ihr Creative zur Prüfung bereit ist.
    Download: Herunterladen
    downloadAll: Alle herunterladen
    downloadAsZip: Als .zip herunterladen
    exportMenu: Exportieren
    Modal: Modal
    'Order Now': Projekt starten
    Playdeck: Playdeck
    'Select a business account': Geschäftskonto auswählen
    'View Demo': Demo ansehen
    'View Playdeck': Playdeck ansehen
    accessRevoked: Zugriff wurde widerrufen.
    afterClickingApprove: 'Nach dem Klicken auf <i>Creatives genehmigen</i> können Sie keine Revisionen mehr anfordern.'
    approveAndProceedBtn: Genehmigen und fortfahren
    automaticOrderApprovalText: 'Dieses Projekt wird {{ when }} automatisch genehmigt.'
    chooseExistingFolder: Bestehenden Ordner auswählen
    close: Schließen
    conceptNameLabel: 'Konzept {{conceptNumber}}:'
    confirmInternalDeliveryModalBtnText: Creatives liefern
    confirmInternalDeliveryModalText: 'Sobald Sie auf <i>Creatives liefern</i> klicken, wird das Projekt an den Kunden geliefert und Sie können keine internen Revisionen mehr anfordern.'
    confirmInternalDeliveryModalTitle: Sind Sie sicher?
    confirmRequestInternalRevisionModalBtnText: Interne Revision anfordern
    confirmRequestInternalRevisionModalDirectiveText: Bitte kommunizieren Sie Lieferverzögerungen entsprechend, um Kundenerwartungen zu steuern.
    confirmRequestInternalRevisionModalText: 'Sobald Sie auf <i>Interne Revision anfordern</i> klicken, werden Sie zum Review-Link weitergeleitet, um Ihre internen Revisionskommentare hinzuzufügen. Wenn Sie fertig sind, verschieben Sie die Trello-Karte auf <i>Revision Needed</i>, damit die Produktion mit der Bearbeitung Ihrer Anfrage beginnen kann.'
    confirmRequestInternalRevisionModalTitle: Interner Revisionsprozess
    continue: Weiter
    copyLink: Link in Zwischenablage kopiert
    copyVariationNumber: 'Textvariation {{copyVariationNumber}}'
    createNewFolder: Neuen Ordner erstellen
    creativeFolder: Creative-Ordner
    deliverableBadgeApproved: Hero genehmigt
    deliverableBadgeAwaiting: Warten auf Prüfung
    deliverableBadgeRevision_one: '{{revisionNumber}} Revision'
    deliverableBadgeRevision_other: '{{revisionNumber}} Revisionen'
    dropboxExportComplete: Dropbox-Export erfolgreich.
    emailInstructions: E-Mail-Anweisungen
    errorNoVideos: 'Entschuldigung, diese Bestellung enthält keine Video-Creatives (nur Bilder), daher können wir sie nicht nach YouTube exportieren'
    exportCompleted: Export abgeschlossen
    exportCurrentlyCreatingDeliverablesText: 'Wir erstellen gerade Ihre ZIP-Datei zum Herunterladen. Bitte schauen Sie in Kürze wieder vorbei.'
    exportError: 'Exportfehler. {{error}}.'
    exportProgress: 'Deliverables werden exportiert: {{progress}}%'
    exportSpinnerText: '{{successCount}} von {{totalCount}} Deliverables exportiert'
    formatNameSelectOptionsTitle: Formate
    frameIOUrlBtn: Revisionskommentare in frame.io hinzufügen
    googleAdsAccount: Google Ads-Konto
    hero: Hero
    baseCopy: Basistext
    inProgressText: Ihr Projekt ist in die nächste Produktionsphase gewechselt. Sie erhalten eine E-Mail, wenn die nächsten Creatives zur Prüfung bereit sind.
    internalDeliveryButtonLabel: Creative liefern
    internalDeliveryModalTitle: Creative liefern?
    internalDeliveryModalBody: Das Projekt wird an den Kunden geliefert und Sie können keine internen Revisionen mehr anfordern. Bitte kommunizieren Sie Lieferverzögerungen entsprechend, um Kundenerwartungen zu steuern.
    internalDeliveryRequestRevision: Interne Revision anfordern
    internalDeliveryRevisionInProgress: Interne Revision in Bearbeitung
    languageSelectOptionsTitle: Sprachen
    letsGoText: Los geht’s!
    linkCopied: Der Link wurde in Ihre Zwischenablage kopiert.
    modalDeleteCancelButton: Abbrechen
    mustBeLoggedInToApproveText: aber Sie müssen angemeldet sein, um das Projekt zu genehmigen.
    newFolderName: Neuer Ordnername
    noMatchingCreatives: Es gibt keine passenden Creatives. Bitte versuchen Sie andere Filter.
    numHeroesRevised_one: '{{numRevisionRequests}} Hero hat Revisionen.'
    numHeroesRevised_other: '{{numRevisionRequests}} von {{numHeroes}} Heroes haben Revisionen.'
    numHeroPendingReview_one: '{{numHeroPendingReview}} Hero wartet auf Prüfung.'
    numHeroPendingReview_other: '{{numHeroPendingReview}} von {{numHeroes}} Heroes warten auf Prüfung.'
    orderApproveActionsText: 'Nach Genehmigung dieses Projekts erhalten Sie Zugriff auf Ihre Creatives.'
    orderConfirmationText: 'Sobald Sie diese Creatives genehmigen, geht Ihr Projekt in die nächste Phase über, und die nächsten Creatives werden produziert und an Sie geliefert. Sobald Ihr Projekt in die nächste Phase übergegangen ist, können Sie für diese Creatives keine Revisionen mehr anfordern.'
    orderNumber: ' #{{orderNumber}}'
    orderStateLabel: 'Status:  <1>{{orderState}}</1>'
    proceedToProduction: Zur Vollproduktion fortfahren
    proceedToProductionDialogTitle: Sind Sie sicher?
    proceedToProductionDialogDescription: Sobald Sie diese Creatives genehmigen, geht Ihr Projekt in die nächste Phase über, und die nächsten Creatives werden produziert und an Sie geliefert. Sobald Ihr Projekt in die nächste Phase übergegangen ist, können Sie für diese Creatives keine Revisionen mehr anfordern.
    requestChangesText: . Bitte kontaktieren Sie Ihren <1>Client Partner</1>, um weitere Änderungen anzufordern.
    requestRevision: Revision anfordern
    removeFilterBtnLabel: 'Filter entfernen ({{totalFilters}})'
    reviewBtnLabel: 'Prüfen'
    revisionCommentInfoText: 'Bitte beachten: Ihre Revision ist möglicherweise bereits in Arbeit. Wenn Sie zusätzliche Kommentare hinzugefügt haben, informieren Sie bitte Ihren Account Manager.'
    revisionConfirmationText: Ihr Projekt wird überarbeitet. Sie erhalten eine E-Mail, sobald die Revisionen abgeschlossen sind.
    revisionRequestConfirmationBtn: Revision anfordern
    revisionRequestConfirmationText: Geben Sie klare und umsetzbare Kommentare, damit unser Design-Team Ihre Revisionen genau umsetzen kann. Bei größeren Änderungen kontaktieren Sie bitte Ihren Creative Specialist.
    revisionRequestConfirmationTitle: Sind Sie sicher?
    revisionRequestFrameIoBtn: Frame.io
    revisionRequestFrameIoLink: Neu bei Frame.io? So funktioniert es
    revisionRequestHeading: Revision für Ihr Projekt anfordern
    revisionRequestStep1Description: Klicken Sie auf den <strong>Frame.io</strong>-Link unten, um Ihre Creatives anzusehen.
    revisionRequestStep1Label: Schritt 1 - Zu Frame.io gehen
    revisionRequestStep2Description: Kommentieren und zeichnen Sie in den Bereichen, in denen Sie eine Revision möchten.
    revisionRequestStep2Label: Schritt 2 - Feedback geben
    revisionRequestStep3Description: 'Wenn Sie fertig sind, kehren Sie zu dieser Seite zurück und klicken Sie auf <strong>Revision einreichen</strong>'
    revisionRequestStep3Label: Schritt 3 - Revision einreichen
    revisionRequestSubHeading: Stellen Sie sicher, dass alles passt, bevor wir Ihre erfolgreiche Kampagne paketieren
    revisionRequestSubmitRevision: Revision einreichen
    revisionSubmitConfirmationModalBtn: Revision einreichen
    revisionSubmitConfirmationModalText: Sobald Sie auf <strong><i>Revision einreichen</i></strong> klicken, wird Shuttlerock benachrichtigt, mit der Bearbeitung der Anfragen zu beginnen. In Frame.io können dann keine weiteren Kommentare oder Bearbeitungen vorgenommen werden.
    revisionSubmitConfirmationModalTitle: Sind Sie sicher?
    revokeAccessToMyYoutubeAccount: Zugriff auf mein Konto entziehen
    resultFilters: 'Ergebnisse ({{numOfResults}})'
    seconds: Sekunden
    selectAnAdvertiser: Werbetreibenden auswählen
    selectFolder: Ordner auswählen
    sendExportInstructionsToSomeoneElse: Exportanweisungen an eine andere Person senden
    sendInstructionsToSomeoneElse: Anweisungen an eine andere Person senden
    sentToProduction_one: '{{numRevisionRequests}} Deliverable wird zur Produktion gesendet'
    sentToProduction_other: '{{numRevisionRequests}} Deliverables werden zur Produktion gesendet'
    shareUrlButtonText: 'Teilen'
    sortAndFilterMenuTitle: Filter
    submitRevisions: Revisionen einreichen
    unitNumber: 'Unit {{unitNumber}}'
    viewBriefSummary: Projektbriefing
    viewBtnLabel: Ansehen
    wouldYouLike: Möchten Sie diese Links an Ihr Team mailen?
    youDontHaveGoogleAdsAccount: Sie haben kein Google Ads-Konto
    youHaveWithCount_one: '{{revisionLeft}} von {{maxNumRevisions}} Revision verbleibend'
    youHaveWithCount_other: '{{revisionLeft}} von {{maxNumRevisions}} Revisionen verbleibend'
    youtubeMenuModalHeading: Wie möchten Sie Ihre Deliverables exportieren?
  orderDeliverableUpload:
    activeAdmin: 'Active Admin:'
    amplifyLink:
      amplifyTemplateID: Amplify-Template-ID
      amplifyTemplateIDRequired: Amplify-Template-ID erforderlich
      amplifyTemplateLinkSuccessMsg: Das Abrufen der Deliverables aus Amplify wurde gestartet und kann eine Weile dauern. Aktualisieren Sie die Seite, um den aktuellen Stand zu sehen.
      conceptName: Konzept {{position}} – {{name}}
      linkATemplate: Template verknüpfen
      linkTemplate: Template verknüpfen
      matchedCompCount: 'Übereinstimmende Comps: {{count}}'
      matchingCompNotFound: Keine passende Comp gefunden
      reload: Neu laden
      renderingDeliverables: Deliverables werden gerendert ({{renderedCount}}/{{totalCount}} fertig) …
      replace: Ersetzen
      viewInAmplify: In Amplify anzeigen
    amplifyTemplateImport:
      import: Importieren
      importFromAmplifyTemplate: Aus Amplify-Template importieren
      amplifyTemplateID: Amplify-Template-ID
      amplifyTemplateIDRequired: Amplify-Template-ID erforderlich
      compositions: Kompositionen
      compositionsRequired: Mindestens eine Komposition muss ausgewählt werden
      revision: Revision {{versionNumber}}
      revisions: Revisionen
      templateImportSuccessMsg: Die Kompositionen des Templates wurden erfolgreich importiert.
      templateName: 'Name: {{name}} ({{id}})'
      templateNotFound: Template nicht gefunden
      next: Weiter
      back: Zurück
      finish: Fertig
    audioTypeClientProvided: Vom Kunden bereitgestelltes Audio
    audioTypeNoAudio: Keine Hintergrundmusik
    audioUrlHeaderLabel: Audio-URL
    bitrate: '{{bitrate}}kbps'
    cannotAddDeliverableErrorDesc: Für diese Bestellung können keine Deliverables mehr hochgeladen werden.
    cannotAddDeliverableErrorTitle: 'Diese Seite ist nicht mehr verfügbar:'
    conceptHeaderLabel: Konzept
    conceptOptionLabel: 'Konzept {{number}} - {{name}}'
    confirmDelete: Löschen
    confirmDeleteText: Möchten Sie dieses Deliverable wirklich löschen?
    confirmDeleteTitle: Deliverable löschen?
    containsAIOptions:
      NO: Nein
      UNSURE: Nicht sicher
      YES: Ja, enthält KI
    containsAiHeaderLabel: Enthält KI
    containsAiHeaderTooltip: Wählen Sie „Ja“, wenn ein in diesem Konzept verwendetes Asset (Bild, Audio, Video oder Musik) überwiegend mit einem KI-Modellanbieter (z. B. Midjourney, Luma AI, ElevenLabs oder Sora) generiert oder wesentlich bearbeitet wurde (z. B. Hintergrundgenerierung, Produktplatzierungen usw.).
    currentState: 'Aktueller Status:'
    currentWorkflowStep: 'Aktueller Workflow-Schritt:'
    deletePermissionError: Sie haben leider keine Berechtigung, dieses Deliverable zu archivieren.
    deliverableExportNameHeaderLabel: Export-Dateiname
    deliverableFormat: Deliverable-Format
    deliverableFormatErrorRequired: Bitte geben Sie ein gültiges Format für dieses Deliverable ein
    deliverableFormatHeaderLabel: Format
    deliverableName: Deliverable-Name
    deliverableNameHeaderLabel: Deliverable-Name
    deliverables: Deliverables
    deliveryPageLink: 'Link zur Lieferseite:'
    duplicateFileFoundDialogActionCancel: Abbrechen
    duplicateFileFoundDialogActionCancelDeprecated: Abbrechen
    duplicateFileFoundDialogActionContinue: Weiter
    duplicateFileFoundDialogActionProceed: Fortfahren
    duplicateFileFoundDialogActionReplaceDeprecated: Datei ersetzen
    duplicateFileFoundDialogContent: Es wurden mehrere Dateien mit identischen Attributen erkannt.
    duplicateFileFoundDialogContentDeprecated: Eine Datei, die Sie hochladen möchten, hat dieselben Dateiattribute wie die Datei „{{fileName}}“, die bereits in dieses Projekt hochgeladen wurde. Möchten Sie diese Datei durch die hochzuladende Datei ersetzen?
    duplicateFileFoundDialogExisting: Vorhanden
    duplicateFileFoundDialogNew: Neu
    duplicateFileFoundDialogOptionKeepOriginalDescription: Keine Änderung. Die neue Datei wird verworfen.
    duplicateFileFoundDialogOptionKeepBothTitle: Beide behalten
    duplicateFileFoundDialogOptionKeepBothDescription: Beide Dateien werden behalten. Der neuen Datei wird eine „Unit“-Nummer hinzugefügt.
    duplicateFileFoundDialogOptionKeepOriginalTitle: Original behalten und neue Datei verwerfen
    duplicateFileFoundDialogOptionUploadNewVersionDescription: Die neue Datei wird als neue Version zur vorhandenen Datei hinzugefügt.
    duplicateFileFoundDialogOptionUploadNewVersionTitle: Neue Datei als neue Version hochladen
    duplicateFileFoundDialogTitle: Doppelte Dateien
    duplicateFileFoundDialogTitleDeprecated: Doppelte Datei gefunden
    durationHeaderLabel: Dauer
    failedUpload: Upload fehlgeschlagen
    failedUploadUnsupported: Upload fehlgeschlagen – Dateityp nicht unterstützt.
    fileTypeHeaderLabel: Dateityp
    footerHelperText: Nach dem Speichern erscheinen Ihre Dateien im Tab „Review“ und können genehmigt werden.
    fps: '{{fps}}fps'
    heightHeaderLabel: Höhe
    heroHeaderLabel: Hero
    heroLabel: Hero {{position}}
    languageHeaderLabel: Sprache
    loading: Wird geladen
    localeHeaderLabel: Locale
    lockedTooltip: Genehmigt
    measurementUnitHeaderLabel: Maßeinheit
    amplifyLinkHeaderLabel: Amplify-Link
    newAssetHelperText: Legen Sie Dateien ab oder durchsuchen Sie Ihre Dateien. Wir versuchen, sie automatisch den passenden Deliverables zuzuordnen. Sie können die Zuordnungen vor dem Speichern manuell anpassen.
    newAssetLabel: Dateien für dieses Projekt hochladen
    nextWorkflowStep: 'Nächster Workflow-Schritt:'
    originalCreativeOptionLabel: Original-Creative
    platformHeaderLabel: Plattform
    revisionHeaderLabel: Revision
    workingFiles:
      title: Arbeitsdateien
      uploadedCount: '{{count}} erfolgreich hochgeladen.'
      downloadAll: Alles herunterladen
      helperText: 'Optional: Bearbeitbare oder mehrschichtige Dateien (z. B. PSD, AE) hochladen, wenn Empfänger ihre eigenen Bearbeitungen vornehmen.'
      columnHeadings:
        filename: Name
        uploader: Hochgeladen von
        uploadedAt: Hochgeladen am
        size: Größe
      empty: Keine Dateien
    saveButton: Speichern
    saveOrderBtn: Projekt speichern
    saved: Das Projekt wurde gespeichert
    state: Status
    title: Deliverables hochladen
    titleErrorRequired: Dieses Feld ist erforderlich.
    unitHeaderLabel: Unit
    uploadAudioUrlInvalidText: ' {{audioUrlInvalidCount}} ungültige Audio-URLs.'
    uploadDeliverableFileExtensionInvalid_one: ' Bei {{count}} Deliverable-Datei stimmt die Dateiendung nicht mit dem Original überein.'
    uploadDeliverableFileExtensionInvalid_other: ' Bei {{count}} Deliverable-Dateien stimmt die Dateiendung nicht mit dem Original überein.'
    uploadDeliverableFileNameInvalid_one: ' {{count}} Deliverable-Dateiname enthält nicht unterstützte Zeichen.'
    uploadDeliverableFileNameInvalid_other: ' {{count}} Deliverable-Dateinamen enthalten nicht unterstützte Zeichen.'
    uploadErrorText: ' {{uploadErrorCount}} fehlende Pflichtfelder.'
    uploadHeroMissingText: ' Für Konzept {{heroMissingConcepts}} muss ein Hero festgelegt werden.'
    uploadSuccessText: ' {{uploadSuccessCount}} erfolgreich hochgeladen.'
    variantHeaderLabel: Variante
    utility:
      assistant: Assistent
      overview: Übersicht
      summary: Zusammenfassung
    versionHeaderLabel: Version
    widthHeaderLabel: Breite
    yes: Ja
    newVariantOption: '+ Neue Variante'
    createVariantDialog:
      title: Neue Variante erstellen
      titleWithConcept: 'Neue Variante erstellen — {{conceptName}}'
      sequenceLabel: Variantennummer
      sequenceRequired: Variantennummer ist erforderlich
      sequenceInvalid: Muss eine ganze Zahl sein
      sequenceMin: Muss 0 oder größer sein
      sequenceDuplicate: Diese Variantennummer existiert bereits
      nameLabel: Name
      nameRequired: Name ist erforderlich
      namePlaceholder: Variantenname eingeben
      createButton: Erstellen
    batchNameVariantsDialog:
      title: Neue Varianten benennen
      variantLabel: 'Variante {{sequence}}'
      nameRequired: Name ist erforderlich
      placeholder: Variantenname eingeben
      saveButton: Speichern
  orderList:
    actionFilterBtnLabel: Filter ({{totalFilters}})
    brandsSelectOptionsTitle: Marken
    clientPartnersSelectOptionsTitle: Kundenpartner
    clientsSelectOptionsTitle: Kunden
    creativeSpecialistsSelectOptionsTitle: Creative Specialists
    groupsSelectOptionsTitle: Gruppen
    regionsSelectOptionsTitle: Regionen
    removeFilterBtnLabel: Filter entfernen ({{totalFilters}})
    resultFilters: Ergebnisse ({{numOfResults}})
    salesTerritorySelectOptionsTitle: Vertriebsgebiet
    searchPlaceholder: Suchen
    sortAndFilterMenuTitle: Sortieren und filtern
    statusGroupTitle: Status
    statusPlaceholder: Beliebiger Status
    title: Projektübersicht
  orderListTable:
    actions: Aktionen
    actionsAdjustRevisions: Revisionslimit anpassen
    actionsBtnAriaLabel: Aktionsmenü für Bestellung öffnen
    actionsConfirmOrder: Briefing genehmigen
    actionsContinueOrder: Projekt fortsetzen
    actionsDelete: Löschen
    actionsReorder: Erneut bestellen
    actionsReviewCreatives: Creatives prüfen
    actionsViewCreatives: Creatives ansehen
    addDeliverablesLabel: Deliverables hinzufügen
    brand: Marke
    briefSummaryLabel: Briefing-Zusammenfassung
    cancelBtn: Abbrechen
    client: Kunde
    customOrderLabel: Individuelle Bestellung
    emptyTableMessage: Es sind keine Projekte vorhanden. Klicken Sie oben auf „Neues Projekt“, um ein neues Projekt zu starten.
    maxNumRevisionsLabel: Maximale Anzahl Revisionen
    maxNumRevisionsPlaceholder: Anzahl der Revisionen festlegen
    modalAdjustRevisionsTitle: 'Maximale Anzahl an Revisionen für den Schritt festlegen: {{workflowStep}}'
    modalConfirmOrderTitle: Möchten Sie dieses Briefing wirklich genehmigen?
    modalDeleteCancelButton: Abbrechen
    modalDeleteConfirmationButton: Projekt löschen
    modalDeleteConfirmationText: Dieses Projekt wird entfernt. Möchten Sie wirklich fortfahren?
    modalDeleteConfirmationTitle: Sind Sie sicher?
    orderName: Projektname
    orderNumber: 'Projektnummer: {{serialId}}'
    productionBriefLabel: Produktionsbriefing
    status: Status
    submitBtn: Revisionslimit anpassen
    successDeleteContent: Ihr Projekt wurde erfolgreich gelöscht.
    successDeleteHeader: Entwurf gelöscht
  orderState:
    asset_production: Asset-Produktion
    cs_review: CS-Review
    ugc_ideation: UGC-Ideenfindung
  orderSummary:
    Back: Zurück
    Edit: Bearbeiten
    Update: Aktualisieren
    cancelBtn: Abbrechen
    orderNotificationTitle: Wer soll benachrichtigt werden, wenn dieses Projekt fertig ist?
    submitBtn: Projekt einreichen
  orderingSidebar:
    brandAssetsTitle: Marken-Assets
    campaignDetailsTitle: Kampagnendetails
    conceptVariations_one: '{{count}}x Konzeptvariation'
    conceptVariations_other: '{{count}}x Konzeptvariationen'
    reviewMyOrder: Bestellung prüfen
    title: Zusammenfassung
    tooltipMessage: Bei einigen Pflichtfeldern fehlen Antworten
    translationVariations_one: '{{count}}x Übersetzungsvariation'
    translationVariations_other: '{{count}}x Übersetzungsvariationen'
  passwordStrength:
    Password Strength: Passwortstärke
  previewBox:
    audio: Audio
    brand: Marke
    caption: Vorschaubereich
    compressed: ZIP
    font: Schriftarten
    logo: Logos
    music: Musik
    stills: Bilder
    video: Video
  priceList:
    title: Preise
  productCategory:
    blank_category: Keine Kategorie
    image_to_video: Bild zu Video
    multi_channel_videos: Multi-Channel-Videos
    multiple_images_to_video: Mehrere Bilder zu Video
    tvc_to_video: TVC zu Video
    up_to_15_second_videos: Videos bis zu 15 Sekunden
    up_to_30_second_videos: Videos bis zu 30 Sekunden
    up_to_6_second_videos: Videos bis zu 6 Sekunden
    video_and_images: Video und Bilder
    video_only: Nur Video
  questionForm:
    questionErrorRequired: Dies ist eine Pflichtfrage
  salesTerritories:
    ANZ: Australien & Neuseeland
    ASIA: Asien & Pazifik
    DELTA: DELTA
    EMEA: Europa, Naher Osten & Afrika
    JAPAN: Japan
    NAM: Nordamerika
    UKI: Vereinigtes Königreich & Irland
    VIDMOB: VidMob
  setPassword:
    description: 'Bitte geben Sie ein neues Passwort für Ihr Konto ein:'
    expiredDescription: Bitte fordern Sie einen neuen Link zum Zurücksetzen des Passworts an
    expiredTitle: Link zum Zurücksetzen des Passworts abgelaufen
    expiredWarningContent: Der angeforderte Link zum Zurücksetzen des Passworts ist entweder abgelaufen oder wurde bereits verwendet. Bitte geben Sie Ihre E-Mail-Adresse erneut ein, um einen neuen Link zu erhalten.
    expiredWarningTitle: Dieser Link ist nicht mehr gültig
    passwordErrorRequired: Passwort darf nicht leer sein
    passwordLabel: Passwort
    passwordLengthMessage: Das Passwort muss mindestens 12 Zeichen lang sein.
    passwordPlaceholder: Neues Passwort eingeben
    resetPasswordBtn: Passwort zurücksetzen
    resubmitBtn: E-Mail erneut senden
    signUpBtn: Absenden
    title: Passwort festlegen
  signUpForm:
    back: Zurück
    emailErrorEmail: Bitte geben Sie eine gültige E-Mail ein
    emailErrorRequired: E-Mail ist erforderlich
    emailLabel: E-Mail-Adresse
    emailPlaceholder: E-Mail
    firstNameErrorRequired: Vorname ist erforderlich
    firstNameLabel: Vorname
    firstNamePlaceholder: Vorname eingeben
    heading: Registrieren
    lastNameErrorRequired: Nachname ist erforderlich
    lastNameLabel: Nachname
    lastNamePlaceholder: Nachname eingeben
    passwordErrorRequired: Passwort ist erforderlich
    passwordLabel: Passwort
    passwordLengthMessage: Das Passwort muss mindestens 12 Zeichen lang sein.
    passwordPlaceholder: Passwort eingeben
    rememberMeLabel: Angemeldet bleiben
    signUpBtn: Registrieren
    signUpConfirmationText: Eine E-Mail wurde an {{email}} gesendet
    signUpConfirmationTitle: Vielen Dank für Ihre Registrierung!
  signUpGettingStarted:
    alreadyHaveAccount: Sie haben bereits ein Konto?
    continueWithEmail: Mit E-Mail fortfahren
    continueWithFacebook: Mit Facebook fortfahren
    continueWithGoogle: Mit Google fortfahren
    heading: Los geht’s!
    signIn: ' Anmelden'
  submissionStateErrorModal:
    campaignDetails: Kampagnendetails
    description: Kehren Sie zur Briefing-Zusammenfassung zurück, wenn Sie bereit sind, es erneut einzureichen.
    missingInformation: 'Auf den folgenden Seiten fehlen Pflichtangaben:'
    return: Zurück zur Briefing-Zusammenfassung
    title: Ihr Briefing scheint unvollständig zu sein!
  toast:
    saveAndExitOrderBriefDescription: Ihr Briefing wurde erfolgreich gespeichert und wartet auf Sie, wenn Sie zurückkehren.
    saveAndExitOrderBriefTitle: Ihr Briefing wurde gespeichert!
  translatable:
    inputPlaceholder: Geben Sie hier Ihre Antwort ein …
  unconfirmedEmail:
    body: Wir haben Ihnen eine E-Mail zur Bestätigung Ihres Kontos gesendet. Bitte öffnen Sie sie und klicken Sie auf den Link. Keine E-Mail erhalten? <1>Bestätigung erneut senden</1>
    heading: E-Mail nicht bestätigt
  uploadElement:
    uploaderErrorMessage: Beim Anzeigen des Upload-Bereichs ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administrator.
  uploader:
    file: eine Datei
    fileLimitHitWithCount_one: Sie können nur {{count}} Datei hochladen
    fileLimitHitWithCount_other: Sie können nur {{count}} Dateien hochladen
    file_other: Dateien
    noMoreFilesMessage: Sie können keine weiteren Dateien hochladen
    uploaderText: Ziehen Sie {{files}} hierher oder klicken Sie, um den Dateibrowser zu öffnen
  userInvite:
    cancelBtn: Abbrechen
    copyInviteLink: Einladungslink kopieren
    emailErrorRequired: E-Mail ist erforderlich
    emailLabel: E-Mail
    emailPlaceholder: E-Mail
    firstNameLabel: Vorname
    firstNamePlaceholder: Vorname
    lastNameLabel: Nachname
    lastNamePlaceholder: Nachname
    modalContent: Senden Sie eine automatische E-Mail, die den Benutzer zu Shuttlerock Cloud einlädt, oder kopieren Sie den Einladungslink.
    modalHeader: Benutzer einladen
    sendInviteEmail: Einladung per E-Mail senden
    submitBtn: Benutzer erstellen
    userCreatedWithEmail: Das Benutzerkonto wurde erstellt und die Einladungs-E-Mail für Shuttlerock Cloud wurde gesendet
    userCreatedWithoutEmail: Der Benutzer wurde erstellt und der Einladungslink für Shuttlerock Cloud wurde in Ihre Zwischenablage kopiert
  userList:
    actions: Aktionen
    actionsBtnAriaLabel: Aktionsmenü für Benutzer öffnen
    actionsCopyInviteLink: Einladungslink kopieren
    actionsResendInvite: Einladung erneut senden
    actionsSendInvite: Einladung senden
    copyInviteLinkSuccess: Der Einladungslink für Shuttlerock Cloud wurde in Ihre Zwischenablage kopiert
    email: E-Mail
    emptyTableMessage: Es sind keine Benutzer vorhanden. Klicken Sie oben auf „Neuer Benutzer“, um einen neuen Benutzer hinzuzufügen.
    invitationStatus: Einladungsstatus
    inviteAccepted: Einladung angenommen am {{at}}
    inviteCreated: Einladung erstellt am {{at}}
    inviteSent: Einladung gesendet am {{at}}
    newUser: Neuer Benutzer
    notInvited: Nicht eingeladen
    resendInviteSuccessMessage: 'Die E-Mail-Einladung wurde erneut an {{email}} gesendet'
    sendInviteSuccessMessage: Die E-Mail-Einladung wurde an {{email}} gesendet
    userName: Benutzername
  verticals:
    Agency - Global: Agentur - Global
    Agency - Independent: Agentur - Unabhängig
    App Install: App-Installation
    Automotive: Automobil
    Beverages: Getränke
    CPG: CPG
    Charities & Organisations: Gemeinnützige Organisationen & Verbände
    Consumer Goods: Konsumgüter
    Cosmetics & Luxury: Kosmetik & Luxus
    Disruptors: Disruptoren
    ECom: ECom
    Education: Bildung
    Energy & Utilities: Energie & Versorger
    Entertainment: Unterhaltung
    Entertainment & Media: Unterhaltung & Medien
    FinServ: Finanzdienstleistungen
    FinTech: FinTech
    Financial Services: Finanzdienstleistungen
    Food and Beverage: Lebensmittel und Getränke
    Gaming: Gaming
    Government & Politics: Regierung & Politik
    Health & Fitness: Gesundheit & Fitness
    Health & Pharmaceuticals: Gesundheit & Pharma
    Healthcare: Gesundheitswesen
    Organization & Associations: Organisationen & Verbände
    Other: Sonstiges
    Professional Services: Professionelle Dienstleistungen
    Restaurants: Restaurants
    Retail: Einzelhandel
    Services: Dienstleistungen
    Social Commerce: Social Commerce
    Sports & Fitness: Sport & Fitness
    Tech & Telecommunications: Technik & Telekommunikation
    Technology: Technologie
    Telecommunications: Telekommunikation
    Travel: Reisen
    Travel & Leisure: Reisen & Freizeit
    eCommerce: eCommerce
